<template>
  <div class="share-wechat-dialog-wrapper">
    <transition name="fade">
      <div
        v-if="visible"
        class="share-wechat-dialog-container"
        @click="close"
      ></div>
    </transition>
    <transition name="scale">
      <div
        v-if="visible"
        class="share-wechat-content send-to-wechat"
      >
        <span class="share-wechat-title">发送至微信</span>
        <div class="copy-link flex-c pr">
          <div
            class="auth-select-text"
            :class="{ 'auth-select-disabled': !settingData.public_visibility }"
          >
            <template v-if="settingData.public_visibility">
              对获得链接的人
              <span
                v-if="visibilityOptions[settingData.visibility_type]"
                class="font_w_b"
              >
                {{ visibilityOptions[settingData.visibility_type].title }}
              </span>
              <span class="iconfont iconxiala2"></span>
            </template>
            <template v-else>
              <span>已关闭简历分享链接</span>
            </template>
            <div class="auth-select-content pa">
              <div class="auth-select">
                <div
                  class="select-item"
                  :class="[settingData.visibility_type === key ? 'select-item-active' : '']"
                  v-for="key in visibilityOptionsList"
                  :key="key"
                  @click="updatePublicVisibility({ visibility_type: key }, 'visibility_type')"
                >
                  对获得链接的人<span class="font_w_b">{{ visibilityOptions[key].title }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="copy-link-btn"
            :value="shareUrl"
            @click="copyLink"
          >
            复制链接
          </div>
        </div>
        <div class="share-image-content">
          <img
            v-if="shareimg"
            :src="shareimg"
            class="share-cv-qrcode"
          />
        </div>
        <span class="cv-share-desc">复制链接或微信扫码查看</span>
      </div>
    </transition>
  </div>
</template>
<script>
import api from '@/api';
export default {
  name: 'ResumeWxShare',
  data() {
    return {
      settingData: {
        //当前简历权限
        public_visibility: true, //是否公开
        can_comment: true, // 是否可评论
        visibility_type: 20, //公开类型 10: 部分可见 20：全部可见
      },
      visibilityOptionsList: [20, 10], //用户设置-options-排序
      cvEncodedToken: '',
      shareUrl: '',
      shareimg: '',
      visibilityOptions: {
        //用户设置-options
        20: {
          title: '完整可见',
          desc: '可以查看你的完整简历',
        },
        10: {
          title: '保护隐私',
          desc: '可查看简历，但会隐藏你的姓名及联系方式',
        },
      },
      visible: false,
    };
  },
  methods: {
    async getCvSettings() {
      try {
        const res = await api.shareCvs.getCvSettings(this.cvEncodedToken);
        if (res.code === 1000) {
          this.settingData = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    copyLink() {
      this.$copyText(this.shareUrl).then(
        () => {
          this.$message.success('简历链接已复制');
        },
        (error) => {
          this.$message.error('复制失败');
          console.log(error);
        }
      );
    },
    async updatePublicVisibility(data, type) {
      try {
        const res = await api.shareCvs.putCvSettings(this.cvEncodedToken, data);
        if (res.code === 1000) {
          this.settingData = {
            ...this.settingData,
            ...data,
          };
          if (type === 'public_visibility') {
            this.$message.success(data.public_visibility ? '已打开，将自动记录打开链接的人' : '已关闭，打开可记录并管理查看链接的人');
          } else if (type === 'visibility_type') {
            this.$message.success(data.visibility_type === 20 ? '已对获得链接的人完整可见' : '已对获得链接的人保护隐私');
          }
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取加密token
    async getCvEncodedToken() {
      try {
        const cvToken = this.$route.params.token;
        const res = await api.shareCvs.getCvEncodedToken(cvToken, {
          token: cvToken,
          from_admin: false,
        });
        if (res.code === 1000) {
          let { encoded_token } = res.data;
          this.cvEncodedToken = encoded_token;
          this.shareUrl = `${process.env.HOST_ROOT}/cvs/${encoded_token}/share`;
        }
      } catch (error) {
        console.log(error);
      }
    },
    //获取小程序分享码
    async getMiniprogramImg() {
      let cvToken = this.$route.params.token;
      // 获取当前简历的隐私设置
      this.getCvSettings();

      let res = await api.cvsEditor.cvQr(
        {
          is_hyaline: 1,
        },
        cvToken
      );
      if (res.code === 1000) {
        this.shareimg = 'data:image/png;base64,' + res.data.image;
      } else {
        console.log('小程序二维码加载出错');
      }
    },
    show() {
      this.visible = true;
      this.getCvEncodedToken();
      this.getMiniprogramImg();
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.share-wechat-dialog-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 299;
}
.share-wechat-content {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 301;
  margin: auto;
  padding: 32px 20px;
  border-radius: 8px;
  background-color: $form-bg-color;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 340px;
  height: fit-content;
  box-sizing: border-box;
  .share-wechat-title {
    color: $modal-label-text-color;
    margin-bottom: 32px;
    font-size: 24px;
    font-weight: 500;
  }
  .send-to-wechat {
    cursor: default;
  }
  .copy-link {
    position: relative;
    height: 34px;
    border-radius: 6px;
    border: 1px solid $modal-input-border-color;
    background: $modal-input-bg2-color;
    line-height: 34px;
    cursor: pointer;
    font-size: 14px;
    margin-bottom: 24px;
    width: 100%;
    .auth-select-text {
      flex: 1;
      color: $modal-label-text-color;
      padding-left: 16px;
      padding-right: 20px;
      display: flex;
      .iconfont {
        font-size: 12px;
        margin-left: 2px;
      }
      &:hover {
        .auth-select-content {
          display: block;
        }
      }
      .auth-select-content {
        display: none;
        top: 32px;
        left: 0;
        right: 0;
        padding-top: 8px;
        .auth-select {
          border-radius: 6px;
          border: 1px solid $modal-input-border-color;
          text-align: left;
          overflow: hidden;
          &:before {
            width: 100%;
            height: 4px;
            display: block;
            position: absolute;
            content: '';
            top: -6px;
          }
          .select-item {
            line-height: 40px;
            background: $modal-input-bg2-color;
            color: $modal-label-text-color;
            padding-left: 12px;
            cursor: pointer;
            &-select,
            &:hover {
              background: $modal-input-bg2-color;
              color: $theme-color;
            }
            &-select {
              font-weight: 500;
            }
          }
        }
      }
    }
    .auth-select-disabled {
      color: $modal-label-text-color;
      background-color: $btn-disabled-bg-color;
    }
    &-btn {
      width: 94px;
      text-align: center;
      border-left: 1px solid $modal-input-border-color;
      color: #ff6644;
      line-height: 34px;
      &:hover {
        font-weight: bold;
      }
    }
  }
  .share-image-content {
    width: 158px;
    height: 158px;
    background-color: #fff;
    border-radius: 8px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .cv-share-desc {
    color: $tips-color;
    margin-top: 28px;
  }
}
</style>
